<div class="outer">
  @if (brandLoaded) {
    <img [src]="brand.poweredByLogo()" alt="Brand logo" />
  } @else {
    <div style="height: 46px"></div>
  }

  <h1>{{ message }}</h1>

  <p *ngIf="status === 'SUCCESS'">
    <button class="btn btn-primary" (click)="home()">Home Page</button>
    You will be redirected to the home page shortly.
  </p>

  <div *ngIf="status === 'ERROR'">
    <p *ngIf="groups.length === 0">
      If this is your first time accessing this application, there may be a
      small delay while your account is set up. Please try again in a few
      minutes. If the problem persists, contact your system administrator.
    </p>
  </div>

  <div *ngIf="status === 'NEEDS_SETUP'">
    <p>
      Your account requires additional settings&mdash;please contact your system
      administrator.
    </p>
  </div>

  <div *ngIf="status === 'PROVISIONING'">
    <p>
      Your account is being provisioned&mdash;please try again in a few minutes.
    </p>
  </div>

  <div *ngIf="status === 'NO_SSO_ROLES'">
    <p>
      Your account does not have appropriate roles defined&mdash;please contact
      your system administrator.
    </p>
  </div>

  <div *ngIf="status === 'UNEXPECTED_SSO_ROLES'">
    <p>
      Your account has roles defined when none are expected&mdash;please contact
      your system administrator.
    </p>
  </div>

  <div *ngIf="status === 'SSO_ROLES_INVALID'">
    <p>
      Your account has invalid roles&mdash;please contact your system
      administrator.
    </p>
  </div>

  <p *ngIf="status === 'PENDING'">Awaiting account information.</p>

  <p *ngIf="status === 'NO_GROUPS'">Awaiting configuration.</p>

  <h4>
    Do not refresh this page. If there's an error or the validation process
    takes more than about 30 seconds, please login again via your organisation's
    portal.
  </h4>
</div>
